import { defineNuxtPlugin } from '#app';
import { useAuthClient } from '#composables/useAuthClient';
import { usePostHog } from '#composables/usePostHog';
import { watch } from 'vue';

/**
 * Client-side auth plugin for the website.
 * Monitors the auth session and identifies/resets the user in PostHog.
 * This ensures that social OAuth logins (which redirect and bypass middleware/page logic)
 * are correctly identified once the session is established, and that the user is reset on logout.
 */
export default defineNuxtPlugin(() => {
  const authClient = useAuthClient();
  const { identifyUser, resetUser } = usePostHog();

  // useSession is a reactive hook from better-auth
  const session = authClient.useSession();

  watch(
    () => session.value.data,
    (data) => {
      if (data?.user) {
        identifyUser(data.user.id, {
          email: data.user.email,
          name: data.user.name,
        });
      } else if (data === null) {
        resetUser();
      }
    },
    { immediate: true }
  );
});
